import { Injectable } from '@angular/core';
import {ApiResponse, BaseHttpService, Branch, Contact} from '@ems/api';
import { HttpClient } from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {HttpCacheManager} from '@ngneat/cashew';
import {Observable} from 'rxjs';


const expandParams = {
  'expand[0]': 'visitingAddress',
  'expand[1]': 'section',
  'expand[2]': 'regionalManager',
  'expand[3]': 'storeManager',
  'expand[4]': 'areaSalesManager',
  'expand[5]': 'updatedBy',
  'expand[6]': 'company',
}

@Injectable({
  providedIn: 'root'
})
export class BranchService extends BaseHttpService {
  override cacheEnabled = false;

  constructor(
    http: HttpClient,
    cookieService: CookieService,
    manager: HttpCacheManager,
  ) {
    super(http, cookieService, manager);
  }

  getAllBranches(params: any): Observable<Branch[]> {
    const queryParams: Record<string, any> = {
      ...expandParams,
      ...params
    };
    return this.getAll('branches', queryParams);
  }

  getBranches(params: any): Observable<Branch[]> {
    this.invalidateCache();
    const queryParams: Record<string, any> = {
      ...expandParams,
      ...params
    };
    return this.get('branches', queryParams);
  }

  getBranch(id: number): Observable<ApiResponse<Branch>> {
    this.invalidateCache();
    const url = `branch/${id}`;
    const queryParams = {
      ...expandParams
    };
    return this.get(url, queryParams);
  }

  createBranch(body: any): Observable<any> {
    const params = {
      'expand[0]': 'createdBy'
    };
    return this.post('branches', body, {}, params);
  }

  updateBranch(id: number, body: any): Observable<any> {
    const params = {
      ...expandParams
    };
    return this.post(`branch/${id}`, body, {}, params);
  }

  deleteBranch(id: number): Observable<any> {
    const params = {
      ...expandParams
    };
    return this.delete(`branch/${id}`, params);
  }

  uploadBranchBatch(id: number, data: any): Observable<any> {
    return this.postFormData(`branch/batch/${id}`, data);
  }

  checkSubsidiaryImportKeys(id: number, body: any) : Observable<any> {
    return this.post(`branch/subsidiary-import-keys/${id}`, body, {}, {});
  }
}
